/**
 * Configuration values for Redoc API components
 * This file contains shared configuration values used across Redoc-related utilities
 */

/**
 * CSS selector for API operation buttons in Redoc UI
 * Used to identify and target operation buttons in the Redoc documentation interface
 */
export const REDOC_OPERATION_BUTTON_SELECTOR = 'button.sc-ecPEgm'
